import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class CountryService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/ulke/get-list`)
      .then((response) => {
        return response.data;
      });
  }
}

export default new CountryService();
